module.exports = __webpack_public_path__ + "img/GedankenAnR..05065ffe.jpg";